import he from 'he';

export const sanitizeUUID = (input: string): string => {
  const defInput = input || '';

  const uuid = defInput.substring(0, 8);
  return uuid === '00000000' ? '' : uuid;
};

export const sanitize = (
  untrustedData: string | unknown,
  encodeEverything = false,
): string | unknown => {
  if (typeof untrustedData === 'string') {
    return he.encode(untrustedData, {
      encodeEverything,
    });
  }
  return untrustedData;
};

export const decodeHtml = (input: string): string => {
  return he.decode(input);
};
